"use client"
import { SectionHeadingTitle } from "@/components/SectionTitle";
import { useTranslation } from "@/hooks/translationContext"
import ChatBubbleLeftIcon from "@heroicons/react/24/solid/ChatBubbleLeftIcon";

export default function HomepageCommentHeader() {
    const { t } = useTranslation();

    return (
        <SectionHeadingTitle
            title={t("homepage-commentSection-title", {defaultValue: "Yorum Yap/Soru Sor"})}
            icon={null}
            showRedBar
        />
    )
}